import React, { useState } from 'react'
import { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify';
import { Form } from 'react-bootstrap';
import { getDBSDocumentById, viewUserById } from '@app/services/user';
import PreviewModal from '../ops-manual/PreviewModal';
import { useSelector } from 'react-redux';
import fileDownload from 'js-file-download';
import moment from 'moment';
import { getExtension } from '@app/services/opsManual';
import { encodeId } from '@app/helpers/base64url';
import { useDecodedParam } from '@app/hooks/useDecodedParam';

const ViewUser = () => {
    const userStatus = [{value:'active', label:'Active'}, {value:'inactive', label:'Inactive'}];
    let obj: any = {}
    const [isLoading, setLoading] = useState(false);
    const [user, setUserData] = useState(obj);
    const [franchiseList, setFranchiseList] = useState<any[]>([]);
    const [centreGroups, setCentreGroups] = useState<{ roleName: string; centres: any[] }[]>([]);
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [url, setUrl] = useState('');
    const [filename, setFileName] = useState('');
    const [dbsDocuments, setDBSDocuments] = useState([]);
    const [previewingDocId, setPreviewingDocId] = useState<number | null>(null);
    const [docTypeFilter, setDocTypeFilter] = useState('');
    const canAccess = useSelector((state: any) => state.auth.permissions.users);
    const navigate = useNavigate();
    const id = useDecodedParam('encodedId', '/users');
    
    useEffect(() => {
        getUserDetailsById(id);
    }, []);

    const getUserDetailsById = async (id) => {
        try {
            setLoading(true);
            const resp = await viewUserById(id);
            if(resp?.success === true){
                setLoading(false);
                setUserData(resp.collections);
                if(resp?.collections?.franchise !== null){
                    // Franchise Attached only applies to the Franchise Owner role --
                    // every other FC-A role attaches to centres instead, so franchise
                    // records carrying any other role_id are dropped here.
                    const roleList = resp?.collections?.roles || [];
                    const franchiseOwnerRoleId = roleList.find((r: any) => r.slug === 'franchise-owner')?.id;
                    const ownerFranchises = (resp?.collections?.franchise || []).filter(
                        (f: any) => f.role_id === franchiseOwnerRoleId
                    );
                    // De-duplicate franchises by id (a user can hold the Franchise
                    // Owner role at the same franchise via more than one grant).
                    const uniqueFranchises = ownerFranchises.filter(
                        (f: any, i: number, arr: any[]) => arr.findIndex(x => x.id === f.id) === i
                    );
                    setFranchiseList(uniqueFranchises);
                }
                if(resp?.collections?.centre !== null){
                    // The centre list holds one row per (centre, role) assignment, so
                    // the same centre can repeat once per role the user holds there.
                    // Group centres by role so it's clear which centres apply to which role.
                    const centreRecords = resp?.collections?.centre || [];
                    const roleList = resp?.collections?.roles || [];
                    const groupsByRole: Record<number, { roleName: string; centres: any[] }> = {};
                    centreRecords.forEach((record: any) => {
                        const roleId = record.role_id;
                        const roleName = roleList.find((r: any) => r.id === roleId)?.name || 'Other';
                        if (!groupsByRole[roleId]) {
                            groupsByRole[roleId] = { roleName, centres: [] };
                        }
                        // De-duplicate centres within the same role group
                        if (!groupsByRole[roleId].centres.some((c: any) => c.centre_id === record.centre_id)) {
                            groupsByRole[roleId].centres.push(record);
                        }
                    });
                    setCentreGroups(Object.values(groupsByRole));
                }
                if(Object.keys(resp?.collections?.dbs).length > 0){
                    setDBSDocuments(resp?.collections?.dbs?.dbs_documents)
                }
            }else{
                setLoading(false);
                toast.error(resp?.errors[0]?.msg);
                navigate('/users');
            }
        } catch (error: any) {
            setLoading(false);
            toast.error(error?.message || 'Failed');
        }
    };

    const previewFile = async (docId, name) => {
        try{
            setPreviewingDocId(docId);
            const resp = await getDBSDocumentById(docId);
            setUrl(URL.createObjectURL(resp))
            setFileName(name)
            handleShow();
        } catch (error) {
            console.log(error)
        } finally {
            setPreviewingDocId(null);
        }
    }

    const downloadDocument = async (docId, name) => {
        try{
            setLoading(true);
            const resp = await getDBSDocumentById(docId);
            fileDownload(resp, name);
            setLoading(false);        
        } catch (error) {
            setLoading(false);
            console.log(error)
        }
    }

  return (
    <div>
        <section className="content">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-12">
                        <div className="card card-primary">
                            <div className="card-header">
                                <h3 className="card-title">View User</h3>
                            </div>
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label htmlFor="exampleInputEmail1">First Name </label>
                                            <dd>{user?.first_name ? user?.first_name : '---'}</dd>
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label htmlFor="exampleInputEmail1">Last Name </label>
                                            <dd>{user?.last_name ? user?.last_name : '---'}</dd>
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label htmlFor="exampleInputEmail1">Email </label>
                                            <dd>{user?.email ? user?.email : '---'}</dd>
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label htmlFor="exampleInputEmail1">Alternate Email </label>
                                            <dd>{user?.alt_email ? user?.alt_email : '---'}</dd>
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label htmlFor="exampleInputEmail1">Mobile </label>
                                            <dd>{user?.phone ? user?.phone : '---'}</dd>
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label htmlFor="exampleInputEmail1">Alternate Mobile </label>
                                            <dd>{user?.alt_phone ? user?.alt_phone : '---'}</dd>
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label htmlFor="exampleInputEmail1">Address </label>
                                            <dd>{user?.address ? user?.address : '---'}</dd>
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label htmlFor="exampleInputEmail1">Status </label>
                                            <dd>{user?.status ? (userStatus.find(obj => { return obj.value === user?.status}))?.label : '---'}</dd>
                                        </div>
                                    </div>
                                    { user?.roles?.some((r: any) => r.slug === 'admin') && (
                                        <div className="col-sm-4">
                                            <div className="form-group">
                                                <label>Impersonation</label>
                                                <dd>
                                                    <span className={`badge ${user?.impersonation_enabled ? 'badge-success' : 'badge-secondary'}`}>
                                                        {user?.impersonation_enabled ? 'Enabled' : 'Disabled'}
                                                    </span>
                                                </dd>
                                            </div>
                                        </div>
                                    )}
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label htmlFor="exampleInputEmail1">Roles </label>
                                            <dd>
                                                {user?.roles?.length > 0 ? (
                                                    <div className="d-flex flex-wrap" style={{ gap: '4px' }}>
                                                        {user.roles.map((r: any) => (
                                                            <span key={r.id} className="badge badge-primary">{r.name}</span>
                                                        ))}
                                                    </div>
                                                ) : '---'}
                                            </dd>
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label htmlFor="exampleInputEmail1">Franchise Attached </label>
                                            <dd>
                                                {franchiseList.length > 0 ? (
                                                    <div className="mb-2">
                                                        <div className="text-muted small">Franchise Owner:</div>
                                                        <div className="d-flex flex-wrap" style={{ gap: '4px' }}>
                                                            {franchiseList.map((f: any) => (
                                                                <span key={f.id} className="badge badge-light border">{f.name}</span>
                                                            ))}
                                                        </div>
                                                    </div>
                                                ) : '---'}
                                            </dd>
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label htmlFor="exampleInputEmail1">Centre Attached </label>
                                            <dd>
                                                {centreGroups.length > 0 ? (
                                                    <div>
                                                        {centreGroups.map((group) => (
                                                            <div key={group.roleName} className="mb-2">
                                                                <div className="text-muted small">{group.roleName}:</div>
                                                                <div className="d-flex flex-wrap" style={{ gap: '4px' }}>
                                                                    {group.centres.map((c: any) => (
                                                                        <span key={c.centre_id} className="badge badge-light border">{c.name}</span>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                ) : '---'}
                                            </dd>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card-footer">
                                <Link className="btn btn-primary mr-2" to={`/users/edit/${encodeId(id)}`}> <i className="fas fa-pencil-alt"></i> Edit</Link>
                                <Link className="btn btn-default" to='/users'>Close</Link>
                            </div>
                        </div>
                    </div>
                    {canAccess['view-dbs'] && (
                        <div className="col-md-12">
                        <div className="card card-primary">
                            <div className="card-header">
                                <h3 className="card-title">DBS & Compliance</h3>
                            </div>
                            <div className="card-body">
                                
                                {user?.dbs && Object.keys(user?.dbs).length == 0 && (
                                    <div className='col-md-12'>
                                        <span className='text-danger'>No DBS certificate details have been added for this user.</span>
                                    </div>
                                )}
                                {user?.dbs && Object.keys(user?.dbs).length > 0 && (
                                    <>
                                    <div className="row">
                                        <div className="col-sm-12 mb-1">
                                            <strong style={{borderLeft: '3px solid #007bff', paddingLeft: '8px'}}>DBS</strong>
                                        </div>
                                        <div className="col-sm-4">
                                            <div className="form-group">
                                                <dt>DBS Cert. Date </dt>
                                                <dd>{ user?.dbs?.cert_date ? moment(user?.dbs?.cert_date).format('DD/MM/YYYY') : '---' }</dd>
                                            </div>
                                        </div>
                                        <div className="col-sm-4">
                                            <div className="form-group">
                                                <dt>DBS Cert. Number </dt>
                                                <dd>{ user?.dbs?.cert_number ?? '---' }</dd>
                                            </div>
                                        </div>
                                        <div className="col-sm-4">
                                            <div className="form-group">
                                                <dt>DOB For Update Service Check </dt>
                                                <dd>{ user?.dbs?.update_service_check_date ? moment(user?.dbs?.update_service_check_date).format('DD/MM/YYYY') : '---' }</dd>
                                            </div>
                                        </div>
                                        <div className="col-sm-4">
                                            <div className="form-group">
                                                <dt>Update Service </dt>
                                                <dd>{ user?.dbs?.update_service ? 'Yes' : 'No' }</dd>
                                            </div>
                                        </div>
                                        <div className="col-sm-4">
                                            <div className="form-group">
                                                <dt>DBS Cert Copy Held? </dt>
                                                <dd>{ user?.dbs?.status_issues ? 'Yes' : 'No' }</dd>
                                            </div>
                                        </div>
                                        <div className="col-sm-4">
                                            <div className="form-group">
                                                <dt>Surname Per DBS Cert For Update Service Check </dt>
                                                <dd>{ user?.dbs?.surname_cert ?? '---' }</dd>
                                            </div>
                                        </div>
                                        {/* {(() => { const doc = [...dbsDocuments].filter((d: any) => d.certificate_type === 'dbs').sort((a: any, b: any) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime())[0]; return doc ? (
                                            <div className="col-sm-4">
                                                <div className="form-group">
                                                    <dt>Latest Document</dt>
                                                    <dd><a href='javascript:void(0)' onClick={() => previewFile(doc.id, doc.name)}>{previewingDocId === doc.id ? <i className="fas fa-spinner fa-spin mr-1"/> : <i className="fas fa-eye mr-1"/>}{doc.name}</a></dd>
                                                </div>
                                            </div>
                                        ) : null; })()} */}
                                    </div>

                                    <hr className="my-2"/>
                                    <div className="row">
                                        <div className="col-sm-12 mb-1">
                                            <strong style={{borderLeft: '3px solid #007bff', paddingLeft: '8px'}}>Safeguarding</strong>
                                        </div>
                                        <div className="col-sm-4">
                                            <div className="form-group">
                                                <dt>Certificate Date</dt>
                                                <dd>{ user?.dbs?.safeguarding_cert_date ? moment(user?.dbs?.safeguarding_cert_date).format('DD/MM/YYYY') : '---' }</dd>
                                            </div>
                                        </div>
                                        {(() => { const doc = [...dbsDocuments].filter((d: any) => d.certificate_type === 'safeguarding').sort((a: any, b: any) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime())[0]; return doc ? (
                                            <div className="col-sm-4">
                                                <div className="form-group">
                                                    <dt>Safeguarding Certificate</dt>
                                                    <dd><a href='javascript:void(0)' onClick={() => previewFile(doc.id, doc.name)}>{previewingDocId === doc.id ? <i className="fas fa-spinner fa-spin mr-1"/> : <i className="fas fa-eye mr-1"/>}{doc.name}</a></dd>
                                                </div>
                                            </div>
                                        ) : null; })()}
                                    </div>

                                    <hr className="my-2"/>
                                    <div className="row">
                                        <div className="col-sm-12 mb-1">
                                            <strong style={{borderLeft: '3px solid #007bff', paddingLeft: '8px'}}>PVG</strong>
                                        </div>
                                        {(() => { const doc = [...dbsDocuments].filter((d: any) => d.certificate_type === 'pvg').sort((a: any, b: any) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime())[0]; return doc ? (
                                            <div className="col-sm-4">
                                                <div className="form-group">
                                                    <dt>PVG Certificate</dt>
                                                    <dd><a href='javascript:void(0)' onClick={() => previewFile(doc.id, doc.name)}>{previewingDocId === doc.id ? <i className="fas fa-spinner fa-spin mr-1"/> : <i className="fas fa-eye mr-1"/>}{doc.name}</a></dd>
                                                </div>
                                            </div>
                                        ) : null; })()}
                                    </div>

                                    <hr className="my-2"/>
                                    <div className="row">
                                        {dbsDocuments.length > 0 && (
                                            <div className='col-md-12'>
                                            <div className='content'>
                                            <div className='content_inner_wrap'>
                                            <div className='row'>
                                            <div className='col-xl-12'>
                                                <div className="d-flex align-items-center justify-content-between mb-2">
                                                    <b style={{borderLeft: '3px solid #007bff', paddingLeft: '8px'}}>Uploaded Documents</b>
                                                    <div className="d-flex align-items-center">
                                                        <label className="mb-0 mr-2 small">Document Type:</label>
                                                        <Form.Control as="select" size="sm" style={{width: 'auto'}} value={docTypeFilter} onChange={e => setDocTypeFilter(e.target.value)}>
                                                            <option value="">All Types</option>
                                                            <option value="dbs">DBS</option>
                                                            <option value="safeguarding">Safeguarding</option>
                                                            <option value="pvg">PVG</option>
                                                        </Form.Control>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='col-xl-12'>
                                            <div className='list_module_wrapper'>
                                                <table className="table table-bordered" id="client_id_table">
                                                    <tbody>
                                                        <tr className='text-center'>
                                                            <th>Document</th>
                                                            <th>Document Type</th>
                                                            <th>Uploaded At</th>
                                                            <th>Action</th>
                                                        </tr>
                                                        {dbsDocuments.length > 0 && dbsDocuments.filter((f: any) => !docTypeFilter || f.certificate_type === docTypeFilter).map(file => (
                                                            <tr key={file?.id}>
                                                                <td>
                                                                    <a href='javascript:void(0)' onClick={ (e) => { downloadDocument(file?.id, file?.name)} } data-toggle="tooltip" title="Preview" className='mx-3'> 
                                                                        {file?.name}
                                                                    </a>
                                                                </td>
                                                                <td style={{textTransform: 'uppercase'}}>{file?.certificate_type || '-'}</td>
                                                                <td>{file?.created_at ? moment(file.created_at).format('DD/MM/YYYY hh:mm A') : '-'}</td>
                                                                <td className='pl-5'>
                                                                    <a href='javascript:void(0)' onClick={ (e) => { downloadDocument(file?.id, file?.name)} } data-toggle="tooltip" title="Download Document">
                                                                        <i className="fas fa-download mr-2"></i>
                                                                    </a> 
                                                                    { (['docx', 'doc', 'xlsx', 'xls', 'wav'].findIndex((ext) => ext == getExtension(file?.name))) < 0 &&
                                                                        <a href='javascript:void(0)'
                                                                        onClick={ (e) => { previewFile(file?.id, file?.name)} }
                                                                            data-toggle="tooltip" title="Preview Document">
                                                                            {previewingDocId === file?.id
                                                                                ? <i className="fas fa-spinner fa-spin fa-sm mr-2"/>
                                                                                : <i className="fas fa-eye fa-sm mr-2"/>
                                                                            }
                                                                        </a>
                                                                    }
                                                                </td>
                                                            </tr>
                                                        ))}
                                                        {dbsDocuments.length > 0 && dbsDocuments.filter((f: any) => !docTypeFilter || f.certificate_type === docTypeFilter).length === 0 && (
                                                            <tr><td colSpan={4} className="text-muted text-center small">No data available for selected document type.</td></tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            
                                            </div>
                                            </div>
                                            </div>
                                            </div>
                                            </div>
                                            </div>
                                        )}
                                        {dbsDocuments.length == 0 && (
                                            <span className='text-danger'>No DBS documents have been uploaded for this user.</span>
                                        )}
                                    </div>
                                    </>
                                )}
                            </div>
                            <div className="card-footer">
                                <Link className="btn btn-primary mr-2" to={`/users/dbs`} state={{ id, userName: `${user?.first_name} ${user?.last_name}` }}> <i className="fas fa-pencil-alt"></i> Edit DBS Cert.</Link>
                                <Link className="btn btn-default" to='/users'>Close</Link>
                            </div>
                        </div>
                        </div>
                    )}
                </div>
            </div>
            <PreviewModal
                show={show}
                handleClose={handleClose}
                url={url}
                filename={filename}
            />
        </section>
    </div>
  )
}

export default ViewUser;